"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    GOOGLE_APPS: 'Google Apps',
    OFFICE_365: 'Office 365',
    EXCHANGE: 'Exchange',
    ICALENDAR: 'iCalendar',
    CUSTOM_PERMISSIONS: 'Custom permissions',
    REAL_TIME_BOOKING: 'Real time booking',
    HOT_DESKING: 'Hot desking',
    SCHEDULE_BOARD: 'Schedule board',
    SCHEDULE_BOARD_2: 'Schedule board 2',
    ROOM_GRID: 'Room grid',
    TEAM_GRID: 'Team grid',
    JOAN_IN_ROOM: 'Joan in Room',
    JOAN_HOME: 'Joan Home',
    JOAN_SIGN: 'Joan Sign',
    JOAN_ON_TABLETS: 'Joan on Tablets',
    // Alias for STATUS BOARD
    MEETING_LIST: 'Meeting list',
    PARKING: 'Parking',
    CUSTOM_CONTENT: 'Custom content',
    SET_CUSTOM_LOGO: 'Set Custom logo',
    SEND_A_WARM_WELCOME_EMAIL: 'Send a warm welcome email',
    CREATE_CUSTOM_BUTTONS: 'Create Custom Buttons',
    SET_YOUR_PREFERRED_LANGUAGE: 'Set your preferred language',
    MAGIC_MEETING_CHECK_IN: 'Magic meeting check-in',
    CISCO_ROOMKIT_INTEGRATION: 'Cisco Roomkit integration',
    SLACK: 'Slack',
    WEBEX: 'Webex',
    // MSTEAMS: 'MSTeams',
    CHECK_INTO_MEETINGS: 'Check into meetings',
    CLICK_ROOM_BOOKING: '1-click room booking',
    SEE_ONGOING_MEETINGS: 'See ongoing meetings',
    AMAZON_ALEXA_INTEGRATION: 'Amazon Alexa integration',
    CANCEL_NO_SHOW_MEETINGS: 'Cancel no-show meetings',
    ROOM_USAGE_ANALYSIS: 'Room usage analysis',
    OPERATING_HOURS: 'Operating hours',
    LIVE_CHAT_WITH_SUPPORT: 'Live chat with support',
    DEDICATED_SUPPORT_AGENT: 'Dedicated support agent',
    PREMIUM_ONBOARDING: 'Premium onboarding (one-time fee)',
    PROACTIVE_SUPPORT: 'Proactive support',
    GLOBAL_SETTINGS: 'Global settings',
    PER_DEVICE: 'Per device',
    PER_LOCATIONS: 'Per Locations/Building',
    ROOM_CUSTOMIZATION: 'Room customization',
    AMENITIES: 'Amenities',
    FULLY_MANAGED_INFRASTRUCTURE: 'Fully managed infrastructure',
    OPEN_INTEGRATION_API: 'Open integration API',
    CUSTOM_CONTENT_URL_TYPE_IS_VISIBLE: 'customContent.urlType.isVisible',
    ANALYTICS_ADVANCED: 'analytics.advanced',
    DEVICE_WEBSOCKET: 'device.websocket',
    ACCOUNT_JOAN_SIGN_IS_VISIBLE: 'account.JoanSign.isVisible',
    CALENDAR_EMS_IS_VISIBLE: 'calendar.ems.isVisible',
    ACTIVE_DIRECTORY_PROVISIONING_SCIM_DISABLED: 'scim.disabled',
    ACTIVE_DIRECTORY_PROVISIONING_SCIM: 'scim.isEnabled',
    ENTERPRISE_WHITELABEL_ENABLED: 'enterprise.whitelabel.isEnabled',
    SUBSCRIPTIONS_DISABLED: 'subscriptions.disabled',
    LICENSES_ENABLED: 'licenses.enabled',
    LABS_DISABLED: 'labs.disabled',
    USERS_DISABLED: 'users.disabled',
    DESK_DISABLED: 'desk.disabled',
};
